import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const reportsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Reports',
    route: { name: routenames.reports },
  },
];
